import SortBy from '@/pages/intelligence/components/TableComponents/components/SortBy';
import React, { useState } from 'react';
import { Table } from 'tea-component';
import { formatNum, formatPercentNum } from '@/pages/intelligence/utils/commonUtils';

const { pageable,selectable, expandable } = Table.addons;
import "./index.scss"
const StatsExpandtable = (porps: any) => {
  let { tableData, className, gameType } = porps;
  const [selectedKeys, setSelectedKeys] = useState<any>([]);
  const [expandedKeys, setExpandedKeys] = useState<any>([]);
  // console.log('tableData',tableData);

  return (
    // sub-table-fixed 固定子集表格
    <Table
      bordered="all"
      recordKey="id"
      className={`dbi-games-table ${className}`}
      records={tableData.cvmList}
      columns={tableData.columns}
      addons={[
        expandable({
          expandedKeys,
          onExpandedKeysChange: (keys, { event }) => {
            event.stopPropagation();
            setExpandedKeys(keys);
          },
          render(record: any) {
            return <SubTable gameType={gameType} cvmList={record.subList || record.children} />;
          },
        }),
        ...tableData?.addons,
      ]}
    />
  );
};

export default StatsExpandtable;

const SubTable = (props: any) => {
    const { cvmList, gameType } = props;
    const tableColumns=[
      {
        key: 'name',
        header: 'Genre',
        render: (cvm: any) => {
          return <>{cvm?.displayName || cvm?.name}</>;
        },
      },
      {
        key: 'rev',
        header: gameType == 'mobile' || gameType == 'all'  ? 'Revenue($)' : 'Digital Revenue($)',
        align: "right",
        render: (cvm:any) => {
          return <>{formatNum(cvm[gameType == 'mobile' || gameType == 'all'  ? 'rev' : 'digital_rev'], true)}</>;
        },
      },
      {
        key: 'download',
        header: gameType == 'mobile' || gameType == 'all'  ? 'Downloads' : 'Physical Revenue($)',
        align: "right",
        render: (cvm:any) => {
          return <>{formatNum(cvm[gameType == 'mobile' || gameType == 'all' ? 'download' : 'phy_rev'], true)}</>;
        },
      },
    ];

    return (
      <Table
        className="dbi-sub-table"
        verticalTop
        bordered
        records={cvmList}
        columns={tableColumns}
        addons={[pageable()]}
      />
    );
  };

